<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw exclude-auto-rw page-open-right-rw" epub:type="frontmatter dedication" id="Dedication1">
<div class="block-rw dedication-rw" id="dedication1">
<p class="ded-rw" id="p20"><span>For my husband Graham, who makes all my heroes look like chumps. I love you. Go Team Falcon!</span></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s004-Dedication-01.vue?2d545c27